export default __webpack_public_path__ + "static/media/Pistol_4.0cdb810a.png";